module.exports = __webpack_public_path__ + "img/the_infinte_game.e207d490.png";